export default "__VITE_ASSET__D1VR3NZN__"